/* @flow */
import type { OrderedMap } from 'immutable';
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';

export const alerts = getterFromKeyPath(['alerts']);
export const alertList = createSelector(
  alerts,
  (alerts: OrderedMap<any, any>) => alerts.toList(),
);



// WEBPACK FOOTER //
// ./src/app/modules/alerts/getters.js